import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import './Publications.css';

interface Article {
  id: string;
  titulo: string;
  autor: string;
  conteudo: string;
  data: any;
  imagens?: string[];
}

const Publications: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  // Función para eliminar etiquetas HTML de la vista previa
  const stripHtml = (html: string) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const getFirstImage = (article: Article) => {
    // 1. Buscar etiqueta img en el contenido HTML
    const imgRegex = /<img[^>]+src="([^">]+)"/;
    const match = article.conteudo.match(imgRegex);
    if (match && match[1]) return match[1];

    // 2. Buscar en el array de imágenes
    if (article.imagens && article.imagens.length > 0) {
      return article.imagens[0];
    }

    return null;
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const q = query(collection(db, 'articles'), orderBy('data', 'desc'));
        const querySnapshot = await getDocs(q);
        const docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Article));
        setArticles(docs);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchArticles();
  }, []);

  return (
    <div className="publications-page container">
      <header className="page-header">
        <h1>Publicações e Notícias</h1>
        <p>Explore as investigações, notícias e estudos desenvolvidos pelo GIEPEI.</p>
        <div className="underline"></div>
      </header>

      {loading ? (
        <div className="loading-state">Carregando acervo...</div>
      ) : (
        <div className="publications-list">
          {articles.length === 0 ? (
            <p className="no-data">Nenhuma publicação encontrada no acervo.</p>
          ) : (
            articles.map(article => {
              const firstImage = getFirstImage(article);
              return (
                <article key={article.id} className={`pub-item ${firstImage ? 'with-image' : ''}`}>
                  {firstImage && (
                    <div className="pub-image">
                      <img src={firstImage} alt={article.titulo} />
                    </div>
                  )}
                  <div className="pub-content">
                    <h2>{article.titulo}</h2>
                    <p className="pub-author">Autor(es): {article.autor}</p>
                    <p className="pub-excerpt">
                      {stripHtml(article.conteudo).length > 250 
                        ? stripHtml(article.conteudo).substring(0, 250) + "..." 
                        : stripHtml(article.conteudo)}
                    </p>
                    <Link to={`/publicacoes/${article.id}`} className="btn-link">Ler Artigo Completo &rarr;</Link>
                  </div>
                </article>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default Publications;
